import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Menu, MenuItem } from "../ndm/models/menu.model";


@Injectable()
export class SharedService {
    menuList: Subject<Menu> = new Subject();
    constructor() {
    }

    setMenuInfo(data: any) {
        sessionStorage.setItem("menu", data);
    }

    getMenuTitle(url: string) {
        let menuData = sessionStorage.getItem("menu")?.toString();
        let menu = JSON.parse(menuData == null ? '[]' : menuData.toString());
        let selectedMenu: MenuItem = new MenuItem();
        selectedMenu.title = "";
        menu.filter((item: Menu) => item.menuItems !== null).forEach((element: Menu) => {
            element.menuItems.filter(a => (a.route == null ? "" : a.route).toLowerCase() == url).forEach(_menuItem => {
                selectedMenu = _menuItem;
            });
        });

        return selectedMenu;
    }
}